import { render, staticRenderFns } from "./FetchFile.vue?vue&type=template&id=097fd860&scoped=true"
import script from "./FetchFile.vue?vue&type=script&lang=js"
export * from "./FetchFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097fd860",
  null
  
)

export default component.exports